import React from 'react';
import Icon from '@mdi/react';
import { mdiPlus } from '@mdi/js';

const CreateIcon = (props) => {
  return <Icon path={mdiPlus} {...props} />;
};

export default CreateIcon;
